import React from 'react'
import FixedTextTableData from '../../components/tableComponents/FixedTextTableData'
import VariableTextTableData from '../../components/tableComponents/VariableTextTableData'
import DeleteButton from '../../components/tableComponents/DeleteButton'
import { useSelector } from 'react-redux'

const TableRow = ({
	dataElement,
	index,
	setDataElement,
	deleteElement,
	pexEntries,
}) => {
	const ownGroup = useSelector((state) => state.user.value.group.id)

	const pexData = dataElement.permissionData
	const disabled = dataElement.id === ownGroup
	const containsUser = dataElement.containsUser

	function updatePermissionData(attribute, value) {
		const dataCopy = { ...dataElement }
		dataCopy.permissionData[attribute] = value
		setDataElement(dataCopy)
	}

	function updateData(attribute, value) {
		setDataElement({ ...dataElement, [attribute]: value })
	}

	return (
		<tr>
			<FixedTextTableData text={index + 1} />
			<VariableTextTableData
				text={dataElement.name}
				setText={(newText) => {
					updateData('name', newText)
				}}
				disabled={disabled}
			/>
			{pexEntries.map((value) => (
				<td key={value}>
					<input
						type='checkbox'
						checked={pexData[value]}
						disabled={disabled}
						onChange={() => {
							updatePermissionData(value, !pexData[value])
						}}
					/>
				</td>
			))}
			<DeleteButton
				deleteEntry={deleteElement}
				disabled={disabled || containsUser}
				showAsterisk={containsUser && !disabled}
			/>{' '}
			{/* show asterisk to refer to explanation only if group contains users (containsUser) and doesn't contain the current user (disabled) */}
		</tr>
	)
}

export default TableRow
